import generic from '@/shared/utils/generic.js';
import routerNames from './router-names.js';

export default [
  {
    path: '/app/eligible',
    name: routerNames.Home,
    component: () => generic.lazyLoadView(import('../views/eligible.vue')),
  },
  {
    path: '/app/member-non-member',
    name: routerNames.MemberNonMember,
    component: () => generic.lazyLoadView(import('../views/member-non-member.vue')),
  },
  {
    path: '/app/payment',
    name: routerNames.Payment,
    component: () => generic.lazyLoadView(import('../views/payment.vue')),
  },
  {
    path: '/app/confirm-membership',
    name: routerNames.ConfirmMembership,
    component: () => generic.lazyLoadView(import('../views/confirm-membership.vue')),
  },
  {
    path: '/app/validate-mobile',
    name: routerNames.ValidateMobile,
    component: () => generic.lazyLoadView(import('../views/validate-mobile.vue')),
  },
  {
    path: '/app/enquiry-form',
    name: routerNames.EnquiryForm,
    // To be able to use in-component guards, such as beforeRouteEnter, beforeRouteUpdate, and beforeRouteLeave
    // the component has to be imported directly without defineAsyncComponent
    component: () => import('../views/enquiry-form.vue'),
  },
  {
    path: '/app/doc-pack-upload',
    name: routerNames.DocPackUpload,
    component: () => import('../views/doc-pack-upload.vue')
    //component: () => generic.lazyLoadView(import('../views/doc-pack-upload.vue')),
  },
  {
    path: '/app/open-enquiry/:id',
    name: routerNames.OpenEnquiry,
    component: () => generic.lazyLoadView(import('../views/open-enquiry.vue')),
  },
  {
    path: '/app/error',
    name: routerNames.Error,
    component: require('../views/error.vue').default,  
  },
  {
    path: '/app/timeout',
    name: routerNames.Timeout,
    component: require('@/shared/views/timeout.vue').default,
  },
  {
    path: '/app/404',
    name: routerNames[404],
    component: require('@/shared/views/404.vue').default,
    // Allows props to be passed to the 404 page through route params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/app',
    name: "app",
    redirect: '/app/eligible',
  }, 
  {
    path: '/',
    name: "default",
    redirect: '/app/eligible',
  },  
  {
    path: "/:catchAll(.*)",
    name: "catchAll",
    component: require('@/shared/views/404.vue').default,
    // Allows props to be passed to the 404 page through route params, such as `resource` to define what wasn't found.
  },
];